import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { LogRocketService } from './logrocket.service';

export function provideLogRocket(appId: string | undefined): EnvironmentProviders[] {
  return appId
    ? [
      provideAppInitializer(() => inject(LogRocketService).initialize(appId)),
    ]
    : [];
}
